import { cn } from "@/lib/cn";

/**
 * ChapterSection — the recurring reading block used throughout the paper.
 * A calm two-column rhythm: numbered marker + short question on the left,
 * chapter title + narrative prose on the right. Prose is the primary
 * experience; the left column exists only to help the reader navigate.
 */
export const ChapterSection = ({
  id,
  number,
  eyebrow,
  title,
  question,
  children,
  className,
  bordered = true,
}) => {
  return (
    <section
      id={id}
      data-testid={`section-${id}`}
      className={cn(
        bordered && "border-t border-border",
        "scroll-mt-16",
        className
      )}
    >
      <div className="haevn-container py-20 sm:py-24 lg:py-28">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[200px_1fr] lg:gap-16">
          <div className="flex flex-col gap-3">
            {number && (
              <span className="font-mono text-[11px] tabular-nums text-muted-foreground">
                {number}
              </span>
            )}
            {eyebrow && (
              <span className="text-[10px] font-medium uppercase tracking-[0.16em] text-muted-foreground">
                {eyebrow}
              </span>
            )}
            {question && (
              <p className="mt-3 max-w-[180px] text-sm leading-relaxed text-muted-foreground">
                {question}
              </p>
            )}
          </div>
          <div className="max-w-3xl">
            <h2
              className="text-3xl font-medium tracking-tightest text-foreground sm:text-4xl lg:text-[40px] leading-[1.08]"
              data-testid={`section-${id}-title`}
            >
              {title}
            </h2>
            <div className="mt-8 flex flex-col gap-5 text-base leading-relaxed text-foreground/85 sm:text-[17px] sm:leading-[1.65]">
              {children}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChapterSection;
